export default __webpack_public_path__ + "static/badge-f27abdea55904a32ec228eaf126e8b86.svg";